import { on } from "delegated-events";
import ajax from "@common/ajax"
import Konva from 'konva'
import { jsPDF } from "jspdf";

const watchFields = () => {

    const canvas = document.getElementById('konva-wrap')
    const imgURL = canvas.getAttribute('data-img')
    const imgWidth = Number(canvas.getAttribute('data-img-width'))
    const imgHeight = Number(canvas.getAttribute('data-img-height'))
    const backOfCard = canvas.getAttribute('data-backofcard')

    const name = document.getElementById('nameField')
    const title = document.getElementById('titleField')
    const cell = document.getElementById('cellField')
    const phone = document.getElementById('phoneField')
    const fax = document.getElementById('faxField')
    const email = document.getElementById('emailField')
    const address1 = document.getElementById('address1Field')
    const address2 = document.getElementById('address2Field')

    let canvasHeight = imgHeight
    if (backOfCard) {
        canvasHeight = imgHeight * 2
    }

    var stage = new Konva.Stage({
        container: 'konva-wrap',
        width: imgWidth,
        height: canvasHeight
    })

    var layer = new Konva.Layer();
    stage.add(layer)

    var imageObj = new Image();
    imageObj.onload = function () {
      var bc = new Konva.Image({
        x: 0,
        y: 0,
        image: imageObj,
        width: imgWidth,
        height: imgHeight,
      });

      layer.add(bc);
    };
    imageObj.src = imgURL;

    if (backOfCard) {
        var backObj = new Image();
        backObj.onload = function () {
          var bc = new Konva.Image({
            x: 0,
            y: imgHeight,
            image: backObj,
            width: imgWidth,
            height: imgHeight,
          });

          layer.add(bc);
        };
        backObj.src = backOfCard;
    }

    var nameLayer = new Konva.Layer()
    var titleLayer = new Konva.Layer()
    var cellLayer = new Konva.Layer()
    var phoneLayer = new Konva.Layer()
    var faxLayer = new Konva.Layer()
    var emailLayer = new Konva.Layer()
    var address1Layer = new Konva.Layer()
    var address2Layer = new Konva.Layer()

    var nameText = new Konva.Text({
        x: name.getAttribute('data-pos-x'),
        y: name.getAttribute('data-pos-y'),
        fontSize: name.getAttribute('data-font-size'),
        fontStyle: name.getAttribute('data-font-style'),
        fontFamily: name.getAttribute('data-font-family'),
        fill: name.getAttribute('data-color'),
    });
    nameLayer.add(nameText)

    var titleText = new Konva.Text({
        x: title.getAttribute('data-pos-x'),
        y: title.getAttribute('data-pos-y'),
        fontSize: title.getAttribute('data-font-size'),
        fontStyle: title.getAttribute('data-font-style'),
        fontFamily: title.getAttribute('data-font-family'),
        fill: title.getAttribute('data-color'),
    });
    titleLayer.add(titleText)

    var cellText = new Konva.Text({
        x: cell.getAttribute('data-pos-x'),
        y: cell.getAttribute('data-pos-y'),
        fontSize: cell.getAttribute('data-font-size'),
        fontStyle: cell.getAttribute('data-font-style'),
        fontFamily: cell.getAttribute('data-font-family'),
        fill: cell.getAttribute('data-color'),
    });
    cellLayer.add(cellText)

    var phoneText = new Konva.Text({
        x: phone.getAttribute('data-pos-x'),
        y: phone.getAttribute('data-pos-y'),
        fontSize: phone.getAttribute('data-font-size'),
        fontStyle: phone.getAttribute('data-font-style'),
        fontFamily: phone.getAttribute('data-font-family'),
        fill: phone.getAttribute('data-color'),
    });
    phoneLayer.add(phoneText)

    var faxText = new Konva.Text({
        x: fax.getAttribute('data-pos-x'),
        y: fax.getAttribute('data-pos-y'),
        fontSize: fax.getAttribute('data-font-size'),
        fontStyle: fax.getAttribute('data-font-style'),
        fontFamily: fax.getAttribute('data-font-family'),
        fill: fax.getAttribute('data-color'),
    });
    faxLayer.add(faxText)

    var emailText = new Konva.Text({
        x: email.getAttribute('data-pos-x'),
        y: email.getAttribute('data-pos-y'),
        fontSize: email.getAttribute('data-font-size'),
        fontStyle: email.getAttribute('data-font-style'),
        fontFamily: email.getAttribute('data-font-family'),
        fill: email.getAttribute('data-color'),
    });
    emailLayer.add(emailText)

    var address1Text = new Konva.Text({
        x: address1.getAttribute('data-pos-x'),
        y: address1.getAttribute('data-pos-y'),
        fontSize: address1.getAttribute('data-font-size'),
        fontStyle: address1.getAttribute('data-font-style'),
        fontFamily: address1.getAttribute('data-font-family'),
        fill: address1.getAttribute('data-color'),
    });
    address1Layer.add(address1Text)

    var address2Text = new Konva.Text({
        x: address2.getAttribute('data-pos-x'),
        y: address2.getAttribute('data-pos-y'),
        fontSize: address2.getAttribute('data-font-size'),
        fontStyle: address2.getAttribute('data-font-style'),
        fontFamily: address2.getAttribute('data-font-family'),
        fill: address2.getAttribute('data-color'),
    });
    address2Layer.add(address2Text)

    stage.add(nameLayer)
    stage.add(titleLayer)
    stage.add(cellLayer)
    stage.add(phoneLayer)
    stage.add(faxLayer)
    stage.add(emailLayer)
    stage.add(address1Layer)
    stage.add(address2Layer)

    on('keyup', '.address1-field', function(event) {
        address1Text.text(this.value)
    })
    on('keyup', '.address2-field', function(event) {
        address2Text.text(this.value)
    })

    name.addEventListener('keyup', function() {
        nameText.text(this.value)
    })
    name.addEventListener('focus', function() {
        nameText.text(this.value)
    })
    title.addEventListener('keyup', function() {
        titleText.text(this.value)
    })
    title.addEventListener('focus', function() {
        titleText.text(this.value)
    })

    cell.addEventListener('keyup', function() {
        if (this.value != '') {
            cellText.text('C: ' + this.value)
        }
        else {
            cellText.text('')
        }
    })
    cell.addEventListener('focus', function() {
        if (this.value != '') {
            cellText.text('C: ' + this.value)
        }
        else {
            cellText.text('')
        }
    })

    phone.addEventListener('keyup', function() {
        if (this.value != '') {
            phoneText.text('P: ' + this.value)
        }
        else {
            phoneText.text('')
        }
    })
    phone.addEventListener('focus', function() {
        if (this.value != '') {
            phoneText.text('P: ' + this.value)
        }
        else {
            phoneText.text('')
        }
    })


    fax.addEventListener('keyup', function() {
        if (this.value != '') {
            faxText.text('F: ' + this.value)
        }
        else {
            faxText.text('')
        }
    })
    fax.addEventListener('focus', function() {
        if (this.value != '') {
            faxText.text('F: ' + this.value)
        }
        else {
            faxText.text('')
        }
    })


    email.addEventListener('keyup', function() {
        if (this.value != '') {
            emailText.text('E: ' + this.value)
        }
        else {
            emailText.text('')
        }
    })
    email.addEventListener('focus', function() {
        if (this.value != '') {
            emailText.text('E: ' + this.value)
        }
        else {
            emailText.text('')
        }
    })

    address1.addEventListener('focus', function() {
        address1Text.text(this.value)
    })
    address2.addEventListener('focus', function() {
        address2Text.text(this.value)
    })


    const selector = document.getElementById('nameSelectField')
    if (selector) {

        const url = selector.getAttribute('data-url')

        selector.addEventListener('change', async function() {

            const id = this.value
            const path = url + '/' + id

            let response = await ajax.get(path).json();

            if (response['Name']) {

                const name = document.getElementById('nameField')
                const title = document.getElementById('titleField')
                const cell = document.getElementById('cellField')
                const phone = document.getElementById('phoneField')
                const fax = document.getElementById('faxField')
                const email = document.getElementById('emailField')

                let event = new Event("keyup");
                name.value = response['Name']
                name.dispatchEvent(event);
                title.value = response['Title']
                title.dispatchEvent(event);

                if (response['Cell']) {
                    cell.value = response['Cell']
                }
                else {
                    cell.value = ''
                }
                cell.dispatchEvent(event);
                if (response['Phone']) {
                    phone.value = response['Phone']
                }
                else {
                    phone.value = ''
                }
                phone.dispatchEvent(event);

                if (response['Fax']) {
                    fax.value = response['Fax']
                }
                else {
                    fax.value = ''
                }
                fax.dispatchEvent(event);
                if (response['Email']) {
                    email.value = response['Email']
                }
                else {
                    email.value = ''
                }
                email.dispatchEvent(event);

            }


        })

    }

    document.getElementById('save').addEventListener('click', function (e) {
        e.preventDefault()
        let ratio = 'l'
        if (imgWidth < imgHeight) {
            ratio = 'p'
        }

        let canvasHeight = imgHeight
        if (backOfCard) {
            canvasHeight = imgHeight * 2
        }
        var pdf = new jsPDF(ratio, 'px', [imgWidth, canvasHeight]);
        pdf.setTextColor('#000000');

        stage.find('Text').forEach((text) => {
            pdf.text(text.text(), text.x(), text.y(), {
                baseline: 'top',
            });
        });

        pdf.addImage(
            stage.toDataURL({ pixelRatio: 2 }),
            0,
            0,
            imgWidth,
            canvasHeight
        );

        pdf.save('sample.pdf');
    });

}

export default {
  init: () => {

    watchFields()

    const address1 = document.getElementById('address1Field')
    const address2 = document.getElementById('address2Field')

    let event = new Event("focus");
    address1.dispatchEvent(event);
    address2.dispatchEvent(event);

    if (document.getElementsByClassName('proof-form')) {
        // proof page
        const nameField = document.getElementById('nameField')
        nameField.dispatchEvent(event);
        const titleField = document.getElementById('titleField')
        titleField.dispatchEvent(event);
        const cellField = document.getElementById('cellField')
        cellField.dispatchEvent(event);
        const phoneField = document.getElementById('phoneField')
        phoneField.dispatchEvent(event);
        const faxField = document.getElementById('faxField')
        faxField.dispatchEvent(event);
        const emailField = document.getElementById('emailField')
        emailField.dispatchEvent(event);


    }

  },
};

